import { ErrorService } from './../../../core/services/error.service';
import { CampaignService } from '../../../core/services/api/campaign.service';
import { Component, Input, OnInit } from '@angular/core';
import { CampaignSectionFilter } from './campaign-section-filter';
import { finalize } from 'rxjs/operators';
import { Campaign } from '../../../core/models/campaign/campaign';
import { CampaignStatus } from '../../../core/enum/campaign-status.enum';

@Component({
    selector: 'app-campaign-section',
    templateUrl: './campaign-section.component.html',
    styleUrls: ['./campaign-section.component.scss'],
    standalone: false
})
export class CampaignSectionComponent implements OnInit {
  @Input() campaignStatus: CampaignStatus;
  @Input() highlightText: string;
  @Input() title: string;
  @Input() description: string;
  @Input() take: number = 6;
  @Input() color: string = 'red';
  @Input() redirect!: string;
  @Input() redirectParams: object;

  campaigns: Campaign[];
  total: number = 0;
  params: CampaignSectionFilter;
  isLoading: boolean = false;

  constructor(
    private campaignService: CampaignService,
    private errorService: ErrorService,
  ) {}

  ngOnInit() {
    this.params = new CampaignSectionFilter(this.campaignStatus, this.take);
    this.getList(this.params);
  }

  getList(params: CampaignSectionFilter) {
    this.isLoading = true;
    this.campaigns = [];

    this.campaignService
      .getCampaigns(params)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.campaigns = data.data;
          this.total = data.total;
        },
        (err) => {
          this.errorService.showError(err);
        },
      );
  }
}
